import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function ChatPage() {
  return <AppPagePlaceholder name="Chat" />;
}
